import type { FC } from 'preact/compat';

import { Icon24ArrowLeftOutline } from '@vkontakte/icons';
import { Button, Headline, Separator, Title } from '@vkontakte/vkui';
import { clsx } from 'clsx';

import { useWidget } from '../../context/WidgetContext';
import { useAdaptiveWidget } from '../../hooks/useAdaptiveWidget';
import { usePhoneInput } from '../../hooks/usePhoneInput';

import { InputPhone } from '../InputPhone';

import styles from './styles.module.css';

export const PhoneInputOverlay: FC = () => {
  const { isMobile, isTablet } = useAdaptiveWidget();
  const { localeMessages } = useWidget();
  const { phoneNumber, phoneError, showInput, isButtonDisabled, handlePhoneChange, handlePhoneSubmit, handleCancel } =
    usePhoneInput();

  if (!showInput) {
    return null;
  }

  return (
    <div
      className={clsx(styles.phoneInputOverlay, {
        [styles.phoneInputOverlayFullscreen]: isMobile,
        [styles.phoneInputOverlayTablet]: isTablet && !isMobile,
      })}
    >
      <div
        className={clsx(styles.phoneInputContainer, {
          [styles.phoneInputContainerFullscreen]: isMobile,
          [styles.phoneInputContainerTablet]: isTablet && !isMobile,
        })}
      >
        <div className={styles.phoneInputHeader}>
          {isMobile && (
            <button
              type="button"
              className={styles.backButton}
              onClick={handleCancel}
              aria-label={localeMessages.phone.overlayBackAria}
            >
              <Icon24ArrowLeftOutline />
            </button>
          )}
          <div className={styles.phoneInputTitle}>
            <Title level="2">{localeMessages.phone.overlayTitle}</Title>
            <Headline level="2" className={styles.subtitle}>
              {localeMessages.phone.overlaySubtitle}
            </Headline>
          </div>
        </div>
        <Separator />

        <div className={styles.inputWrapper}>
          <InputPhone value={phoneNumber} onChange={handlePhoneChange} error={phoneError} />
        </div>

        <Separator />
        <div className={styles.buttonContainer}>
          {!isMobile && (
            <Button mode="secondary" onClick={handleCancel}>
              {localeMessages.phone.overlayCancel}
            </Button>
          )}
          <Button mode="primary" onClick={handlePhoneSubmit} disabled={isButtonDisabled} stretched={isMobile}>
            {localeMessages.phone.overlayContinue}
          </Button>
        </div>
      </div>
    </div>
  );
};
